import { useState } from 'react';
import { Spin } from 'antd';
import { BillingPlansContext, ActivePlan } from '@/entities/billing-plan';
import { useNotificationContext } from '@/features/notifications';
import {
  PlanResponse,
  PlanUsageResponse,
  useGetPlanUsage,
  useGetPlans,
} from '@/shared/api';
import { useRouterContext } from '@/shared/router';
import { Row } from '@/shared/ui';
import { Plan } from './Plan';

export const PlanAndBilling = () => {
  const { activeOrganization } = useRouterContext();
  const { showNotification } = useNotificationContext();

  const [activePlan, setActivePlan] = useState<ActivePlan>();

  const { data: plansData, refetch: refetchPlansData } = useGetPlans<
    PlanResponse[]
  >({});

  const { data: usageData, refetch: refetchUsageData } =
    useGetPlanUsage<PlanUsageResponse>(
      { pathParams: { organizationId: activeOrganization?.id! } },
      {
        enabled: Boolean(activeOrganization?.id),
        onSuccess: (data) =>
          setActivePlan({
            type: data.plan.type,
            level: data.plan.level,
            subscriptionCancelDate: data.plan.subscriptionCancelDate!,
            manualSubscription: data.plan.manualSubscription,
          }),
        onError(err: any) {
          showNotification({
            message: 'Failed to fetch plan data',
            description: err.stack?.message,
            type: 'error',
          });
        },
      },
    );

  const refetchPlans = () => {
    refetchPlansData();
    refetchUsageData();
  };

  return (
    <BillingPlansContext.Provider value={{ activePlan, refetchPlans }}>
      <Row gap={30} style={{ flexWrap: 'wrap', paddingTop: 20 }}>
        {!activePlan ? (
          <Spin />
        ) : (
          plansData?.map((plan) => {
            return plan.id === usageData?.plan.id ? (
              <Plan key={plan.id} isActive {...plan} {...usageData} />
            ) : (
              <Plan key={plan.id} {...plan} />
            );
          })
        )}
      </Row>
    </BillingPlansContext.Provider>
  );
};
